<template>
  <div class="bottom-bar">
    <div class="bottom-bar__main touch" @click.self="navigateToDefaultPage">
      <a href="http://localhost:9000" class="touch" style="position: absolute; left: 3rem;">
        <img class="bottom-bar__sensoreal-logo" src="/assets/sensoreal.png">
        <!-- <span class="bottom-bar__version">{{ $store.state.version }}</span> -->
      </a>
      <transition-group
        class="bottom-bar__nav-items"
        :class="{ 'dir-rtl' : language.rtl }"
        @before-enter="beforeEnter"
        @enter="enter"
        @afterEnter="afterEnter"
        @leave="leave"
      >
        <div
          v-for="(item, index) in navItems"
          class="bottom-bar__nav-item-wrapper"
          :class="{ 'bottom-bar__nav-item-wrapper--active': isNavItemActive(item) }"
          :data-index="index"
          :key="item._id"
        >
          <router-link
            class="bottom-bar__nav-item touch"
            :class="{ 'bottom-bar__nav-item--active': isNavItemActive(item) }"
            tag="button"
            :to="`/category/${$store.state.route.params.categoryId}/page/${item.pageId}`"
            @click.native="triggerVideo(item.videoWallTrigger); playClickSound()"
          >
            <span class="bottom-bar__nav-label" v-html="item.label[language.code]"></span>
          </router-link>
        </div>
      </transition-group>
    </div>

    <div class="bottom-bar__sub">
      <div v-if="languages.length > 0" class="language-selector">
        <div v-if="showLanguageOptions" class="language-selector__options">
          <div
            v-for="lang in languages"
            :key="lang.code"
            class="language-selector__language"
            @click="setLanguage(lang.code)"
          >
            {{ lang.name }}
          </div>
        </div>
        <div class="language-selector__btn" @click="displayLanguageOptions"><fa :icon="['far', 'globe']"/> {{ language.name }} <fa :icon="['far', 'chevron-down']"/></div>
      </div>
      <router-link
        class="touch"
        tag="button"
        to="/select"
      >
        <img src="../static/aus.png" style="width: 8rem; margin-top: -1rem; padding-left: 1rem;">
      </router-link>

      <router-link
        class="touch"
        tag="button"
        to="/select?region=sa"
      >
        <img src="../static/sa.png" style="width: 5rem">
      </router-link>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  data() {
    return {
      navItems: [],
      showLanguageOptions: false
    }
  },

  computed: {
    ...mapGetters({
      activePage: 'activePage',
      propertyTypes: 'property/propertyTypes'
    }),

    defaultPage () {
      const categoryId = this.$store.state.route.params.categoryId
      let navigation = _.find(this.$store.state.navigation, navigation => {
        return navigation._id === this.$store.state.route.params.categoryId
      })

      return `/category/${categoryId}/page/${navigation.defaultChildId}`
    },

    navigationItems () {
      return this.$store.getters.activeNavigation
    },

    language () {
      return this.$store.getters.language
    },

    languages () {
      return this.$store.getters.languages
    },
  },

  mounted () {
    this.$store.commit('MAIN_NAV_ANIMATE_START')
    setTimeout(() => {
      this.navItems = this.navigationItems
    }, 600)
  },

  methods: {
    ...mapActions([
      'triggerVideo',
      'playClickSound'
    ]),

    beforeEnter (el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(25%)'
    },

    enter (el, done) {
      setTimeout(() => {
        el.style.opacity = 1
        el.style.transform = 'translateY(0)'
        el.style.transition = `transform 0.6s cubic-bezier(0.33, 1, 0.68, 1), opacity 1.2s`
        setTimeout(() => {
          done()
        }, 300)
      }, (parseInt(el.dataset.index) + 1) * 150)
    },

    afterEnter (el) {
      if (parseInt(el.dataset.index) + 1 === this.navItems.length) {
        this.$store.commit('MAIN_NAV_ANIMATE_END')
      }
    },

    leave (el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(25%)'
      el.style.transition = `transform 0.4s cubic-bezier(0.32, 0, 0.67, 0), opacity 0.3s`
    },

    displayLanguageOptions () {
      this.showLanguageOptions = true
    },

    hideLanguageOptions () {
      this.showLanguageOptions = false
    },

    isNavItemActive (item) {
      return this.activePage && (item.pageId === this.activePage._id || _.find(item.children, child => {
        return child.pageId === this.activePage._id
      }))
    },

    setLanguage (languageCode) {
      // TODO get available languages from store / match and commit
      const selectedLanguage = _.find(this.languages, lang => {
        return lang.code === languageCode
      })

      this.$store.commit('SET_LANGUAGE', selectedLanguage)
      this.hideLanguageOptions()
    },

    navigateToDefaultPage (e) {
      this.$router.push(this.defaultPage).catch(() => {})
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";

.bottom-bar {
  bottom: 0;
  left: 0;
  display: flex;
  position: absolute;
  width: 100%;
  z-index: 110;

  &__main {
    align-items: center;
    background-color: $bottombar-bg-color;
    bottom: 0;
    display: flex;
    flex-grow: 1;
    height: 10rem;
    justify-content: center;
    // padding: 1.9rem 0 1.9rem 5rem;
    padding: 1.9rem 0;
  }

  &__sub {
    align-items: flex-start;
    background-color: $bottombar-bg-color;
    display: flex;
    justify-content: flex-start;
    width: 32.5rem;
    padding: 1.9rem 5rem 1.9rem 0;
    height: 10rem;
    justify-content: space-between;
  }

  &__home {
    background-image: url('/assets/sa-regions.png');
    background-repeat: no-repeat;
    background-size: contain;
    font-size: 1.6rem;
    height: 5rem;
    // margin: 0 0 0 3rem;
    margin: 0;
    transform: translateX(1rem);
    width: 5rem;
  }

  &__nav-items {
    align-self: flex-start;
    display: flex;
    flex-grow: 1;
    justify-content: center;
    // padding-left: 1.8rem;
  }

  &__nav-item-wrapper {
    display: flex;

    &--last-item {
      margin-left: 4rem;
      padding: 0 5rem;
      // position: relative;
      position: absolute;
      right: 32.5rem;

      .bottom-bar__nav-item {
        margin: 0;
      }

      &::after {
        background: $bottombar-btn-color;
        content: '';
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        width: .1rem;
      }

      &::before {
        background: $bottombar-btn-color;
        content: '';
        display: none;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        width: .1rem;
      }
    }
  }

  &__nav-item {
    background-color: $bottombar-btn-color;
    border: 1px solid #fff;
    border-radius: 3.5rem;
    color: #fff;
    font-family: $touchscreen-font;
    font-size: 1.25rem;
    font-weight: 400;
    height: 3.5rem;
    letter-spacing: .15rem;
    line-height: 0;
    margin: 0 1rem;
    padding: .1rem 0 0;
    user-select: none;
    width: 17.5rem;

    &.router-link-active, &--active {
      border-color: $bottombar-text-color-active;
      color: $bottombar-text-color-active;
    }
  }

  &__sensoreal-logo {
    width: 11rem;
  }

  &__version {
    color: rgba(255, 255, 255, 0.25);
    display: block;
    text-align: right;
  }

  &__back {
    @include btn($bottombar-btn-color, $bottombar-btn-active-color);
    background-color: $bottombar-btn-color;
    border-radius: .5rem;
    color: #d1d1d1;
    font-family: $touchscreen-font;
    font-size: 1.1rem;
    font-weight: 200;
    height: 3.5rem;
    letter-spacing: .15rem;
    line-height: 0;
    padding: .2rem 1rem 0;
    text-transform: uppercase;

    svg {
      margin-right: .5em;
    }
  }
}

.language-selector {
  display: flex;
  flex-direction: column;
  // margin: 0 auto 0 0;
  position: relative;

  &__options {
    background: $bottombar-bg-color;
    border: .1rem solid $white;
    border-radius: $basic-tag-border-radius;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 6rem;
    z-index: 5;
  }

  &__language {
    color: $white;
    font-size: 1rem;
    letter-spacing: .15rem;
    padding: .5rem;
    text-align: center;
    text-transform: capitalize;
  }

  &__btn {
    border: 0.1rem solid $white;
    border-radius: 1rem;
    color: $white;
    font-size: 1rem;
    height: 2rem;
    letter-spacing: .15rem;
    opacity: .7;
    padding: .2rem .5rem .15rem;
    text-align: center;
    // text-transform: uppercase;
    // width: 6rem;
    pointer-events: none;
  }
}

</style>
